import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedDate } from 'react-intl';
import { IconButton, ListItem, ListItemText, Typography } from '@mui/material';

import { closeDialog } from 'app/store/fuse/dialogSlice';
import { Text, useSettings, Utils, Icon } from 'app/main/components';
import { type ItemLayoutProps } from 'app/main/components/GridList';

export default function DemsMessagesMailchimpListItem(
	props: ItemLayoutProps & { demsUid: string; handleNext: () => void }
) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const openInNew = () => {
		Utils.openLink({ pathname: props.model.thumbnail, newTab: true, external: true });
	};

	const sendDem = () => {
		dispatch(Utils.alertProgressMsg(t));
		Utils.executeApi.get({
			url: `/api/mailchimp/dem/${props.demsUid}/send/${props.model.id}`,
			dispatch,
			successHandler: response => {
				dispatch(Utils.alertSuccessMsg(t));
				dispatch(closeDialog());
				props.handleNext();
			}
		});
	};

	return (
		<ListItem
			divider
			secondaryAction={
				<>
					{/* OPEN PREVIEW IN NEW BUTTON */}
					<IconButton onClick={openInNew} disabled={!props.model.thumbnail}>
						<Icon icon="eye" />
					</IconButton>
					{/* SEND BUTTON */}
					<IconButton onClick={sendDem} edge="end">
						<Icon icon="send" />
					</IconButton>
				</>
			}
		>
			<ListItemText
				className="pr-80"
				slotProps={{
					primary: { component: Text, className: 'font-600', variant: 'subtitle2' },
					secondary: { component: 'div' }
				}}
				primary={props.model.name}
				secondary={
					<>
						{/* CREATION DATE */}
						<Typography variant="subtitle2" color="text.secondary">
							<FormattedDate
								value={Utils.parseDate(props.model.date_edited)?.toDate()}
								year="numeric"
								month="long"
								day="numeric"
								hour="numeric"
								minute="numeric"
							/>
						</Typography>
					</>
				}
			/>
		</ListItem>
	);
}
